export default "__VITE_ASSET__qL6cesNr__"